import React from 'react';
import './Sidebar.css';
import { useNavigate } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaUserCircle,
  FaListUl,
  FaBoxes,
  FaChartLine,
  FaCreditCard
} from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <aside className="sidebar">
      <div className="sidebar-title">Menu</div>

      <button onClick={() => navigate('/dashboard')}>
        <FaTachometerAlt style={{ marginRight: '8px' }} /> Dashboard
      </button>

      <button onClick={() => navigate('/PharmacyProfile')}>
        <FaUserCircle style={{ marginRight: '8px' }} /> Profile
      </button>

      <button onClick={() => navigate('/ManagePharmacyBranch')}>
        <FaListUl style={{ marginRight: '8px' }} /> Manage Branches
      </button>

      <button onClick={() => navigate('/PharmacyBranches')}>
        <FaListUl style={{ marginRight: '8px' }} /> View Branches
      </button>

      <button onClick={() => navigate('/ManageInventory')}>
        <FaBoxes style={{ marginRight: '8px' }} /> Manage Inventory
      </button>

      <button onClick={() => navigate('/analytics')}>
        <FaChartLine style={{ marginRight: '8px' }} /> Analytics
      </button>

      <button onClick={() => navigate('/delete-inventory')}>
        <FaCreditCard style={{ marginRight: '8px' }} /> Subscriptions
      </button>
    </aside>
  );
};

export default Sidebar;
